// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleName.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import RoleNameInput from './Izenda.RoleNameInput';

const RoleName = ({ localization, store, readOnly }: { localization: any, store: any, readOnly: boolean }) => {
  return (
      <div className='form-group u_noMarginAll u_marginRight u_paddingRight u_inlineBlock'>
        <label className='validation required u_marginRight'>
          {localization.getText('ROLE_SETUP_ROLE_DETAIL_LABEL_ROLE_NAME')}
        </label>
        <div className='u_inlineBlock'>
          <RoleNameInput store={store} readOnly={readOnly} />
        </div>
      </div>
  );
};

RoleName.propTypes = {
  store: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

export default connect()(RoleName);



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.RoleName.js